<div class="labeling-central-tile">
    <div
        class="labeling-field"
        [ngClass]="{
            active:
                showImageContainer &&
                selectedImage?.processedUrl &&
                !selectedImage?.error &&
                isImageAndAnnotationsReady,
            shrink:
                !showImageContainer ||
                !selectedImage?.processedUrl ||
                selectedImage?.error ||
                !isImageAndAnnotationsReady,
        }"
    >
        <div class="current-image">
            <div class="current-image-inner">
                <app-image-canvas-viewport
                    [imageUrl]="selectedImage?.processedUrl"
                    [imageWidth]="selectedImage?.width"
                    [imageHeight]="selectedImage?.height"
                    [boxes]="labelingCanvasBoxes"
                    [selectedId]="annotationStateService.selectedAnnotation?.id"
                    [panEnabled]="zoomConfigPanOnClickDrag()"
                    [editable]="canEdit && !zoomConfigPanOnClickDrag()"
                    [drawable]="isEditable() && !zoomConfigPanOnClickDrag()"
                    [selectable]="!zoomConfigPanOnClickDrag()"
                    [showSizeLabels]="showSizeLabels"
                    [maxLevel]="labelCanvasMaxLevel"
                    [level]="canvasLevel"
                    (levelChange)="onCanvasLevelChange($event)"
                    (annotationSelect)="onCanvasSelect($event)"
                    (drawEnd)="onCanvasDrawEnd($event)"
                    (moveStart)="onCanvasModifyStart()"
                    (resizeStart)="onCanvasModifyStart()"
                    (modifyEnd)="onCanvasModifyEnd($event)"
                    (modifyCancel)="onCanvasModifyCancel()"
                    (imageLoaded)="onCanvasImageLoaded()"
                ></app-image-canvas-viewport>
            </div>
        </div>
        <div
            class="feature-buttons-wrapper"
            *ngIf="isImageAndAnnotationsReady && showImageContainer"
        >
            <button
                id="undo-button"
                [disabled]="!annotationStateService.hasUndo() || !canEdit"
                [ngClass]="{
                    disabled: !annotationStateService.hasUndo() || !canEdit,
                }"
                (click)="annotationStateService.undo()"
                (mouseenter)="featureButtonActiveIdx = 0"
                (mouseleave)="featureButtonActiveIdx = null"
                [title]="
                    'imgDb.imgLabeling.featureButtonsWrapper.undo' | translate
                "
            >
                <img
                    [src]="
                        'assets/svg/img-db/labeling-dialog/undo' +
                        (annotationStateService.hasUndo() &&
                        featureButtonActiveIdx === 0
                            ? '-hover'
                            : '') +
                        '.svg'
                    "
                    alt="undo-icon"
                />
            </button>
            <button
                id="redo-button"
                [disabled]="!annotationStateService.hasRedo() || !canEdit"
                [ngClass]="{
                    disabled: !annotationStateService.hasRedo() || !canEdit,
                }"
                (click)="annotationStateService.redo()"
                (mouseenter)="featureButtonActiveIdx = 1"
                (mouseleave)="featureButtonActiveIdx = null"
                [title]="
                    'imgDb.imgLabeling.featureButtonsWrapper.redo' | translate
                "
            >
                <img
                    [src]="
                        'assets/svg/img-db/labeling-dialog/redo' +
                        (annotationStateService.hasRedo() &&
                        featureButtonActiveIdx === 1
                            ? '-hover'
                            : '') +
                        '.svg'
                    "
                    alt="redo-icon"
                />
            </button>
            <button
                id="pan-button"
                [disabled]="currentZoomLevel <= 0"
                (click)="onPanButtonClick()"
                [ngClass]="{
                    disabled: currentZoomLevel <= 0,
                    active: isPanButtonActive,
                }"
                (mouseenter)="featureButtonActiveIdx = 2"
                (mouseleave)="featureButtonActiveIdx = null"
                [title]="
                    'imgDb.imgLabeling.featureButtonsWrapper.pan' | translate
                "
            >
                <img
                    [src]="
                        'assets/svg/img-db/labeling-dialog/pan' +
                        ((currentZoomLevel > 0 &&
                            featureButtonActiveIdx === 2) ||
                        isPanButtonActive
                            ? '-hover'
                            : '') +
                        '.svg'
                    "
                    alt="pan-icon"
                />
            </button>
            <button
                id="ruler-button"
                (click)="onRulerButtonClick()"
                [ngClass]="{ active: isRulerButtonActive }"
                (mouseenter)="featureButtonActiveIdx = 3"
                (mouseleave)="featureButtonActiveIdx = null"
                [title]="
                    'imgDb.imgLabeling.featureButtonsWrapper.ruler' | translate
                "
            >
                <img
                    [src]="
                        'assets/svg/img-db/labeling-dialog/ruler' +
                        (featureButtonActiveIdx === 3 || isRulerButtonActive
                            ? '-hover'
                            : '') +
                        '.svg'
                    "
                    alt="ruler-icon"
                />
            </button>
        </div>
    </div>
    <div
        class="d-flex justify-content-center"
        *ngIf="
            !showImageContainer ||
            (showImageContainer &&
                selectedImage?.processedUrl &&
                !selectedImage?.error &&
                !isImageAndAnnotationsReady)
        "
    >
        <div class="tryb-design-spinner"></div>
    </div>
    <div
        *ngIf="
            showImageContainer &&
            !selectedImage?.processedUrl &&
            !selectedImage?.error
        "
        class="w-100"
    >
        <img
            alt="spinner"
            src="assets/img/img-db/spinner.gif"
            class="img-fluid spinner"
        />
        <div class="text-center message">
            {{ 'imgDb.imgLabeling.stillProcess' | translate }}
        </div>
    </div>
    <div *ngIf="showImageContainer && selectedImage?.error">
        <div class="text-center message">
            {{ 'imgDb.imgLabeling.imgError' | translate }}
        </div>
    </div>
</div>
